module.exports = __webpack_public_path__ + "img/云边端一体化icon.76dade2c.png";